import React from 'react';
import { useParams } from 'react-router-dom';
import { routes } from '../../routes';
import { CompensationReviewDetail } from './CompensationReviewDetail';

// Standalone (top-level) Compensation Review detail.
const CompensationReviewDetailPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <CompensationReviewDetail
      id={id}
      listUrl={routes.compensationReviewsStandalone.route.create({})}
      buildDetailUrl={(reviewId) =>
        routes.compensationReviewStandaloneDetail.route.create({ id: reviewId })
      }
    />
  );
};

export default CompensationReviewDetailPage;
